<p-menubar [model]="menuItems">
	<ng-template #start>
		<img
			[src]="'./assets/img/smartyCubes-small-logo.png'"
			(click)="showHomePage()"
			alt="smarty-logo"
			class="smarty-cube-logo" />
	</ng-template>
	<ng-template #end>
		<div class="end-content">
			<div class="help-wrapper" pTooltip="Yardım" (click)="sidebarVisible = true">
				<i class="fa-solid fa-question icon-help"></i>
			</div>
			<a id="personal-menu-header" class="f-right c-pointer personal-menu-header" (click)="menu.toggle($event)">
				<span>
					<img class="user-image" [src]="userImageUrl" alt="" />
				</span>
				<span class="header-title">
					{{ user.name + ' ' + user.lastName }}
					<i class="fa fa-angle-down" aria-hidden="true"></i>
				</span>
			</a>
		</div>
	</ng-template>
</p-menubar>

<div class="card flex justify-content-center">
	<p-drawer [(visible)]="sidebarVisible" position="right" [style]="{ width: '430px' }">
		<h2 class="mt-0 text-center">{{ 'help' | translate }}</h2>
		<div>
			<h4>{{ 'interactive-demo.interactive-demos' | translate }}</h4>
			<div class="card-content">
				<div class="info" (click)="showIframeAgainDisplayHomepage()">
					<i class="fas fa-list-ul"></i>
					<p>
						{{ 'interactive-demo.demo-menu-explanation' | translate }}
					</p>
					<i class="fa-solid fa-arrow-up-right-from-square"></i>
				</div>
				<div class="info" (click)="showIframeAgainReportPreparation()">
					<i class="fas fa-file-alt"></i>
					<p>
						{{ 'interactive-demo.demo-report-preparation' | translate }}
					</p>
					<i class="fa-solid fa-arrow-up-right-from-square"></i>
				</div>
				<div class="info" (click)="showIframeAgainWidget()">
					<i class="fas fa-th-large"></i>
					<p>{{ 'interactive-demo.demo-widget' | translate }}</p>
					<i class="fa-solid fa-arrow-up-right-from-square"></i>
				</div>
			</div>
		</div>
		<div>
			<h4>{{ 'interactive-demo.documentation' | translate }}</h4>
			<div class="info mt-0">
				<i class="fas fa-book"></i>
				<a target="_blank" href="https://smartycubes.com/doc/">{{ 'interactive-demo.demo-documation' | translate }}</a>
				<i class="fa-solid fa-arrow-up-right-from-square"></i>
			</div>
		</div>
	</p-drawer>
</div>

<p-dialog
	[(visible)]="isShowInteractiveDemoDisplayHomepage"
	[modal]="true"
	[header]="'interactive-demo.demo-menu-explanation' | translate"
	allowfullscreen
	[style]="{ width: '85%', height: '100%' }">
	<iframe
		src="https://app.sharefable.com/embed/demo/smartycubes-giri-c9wdekmq4faq3zpj"
		width="100%"
		height="100%"
		style="border: none"
		allowfullscreen></iframe>
</p-dialog>

<p-dialog
	[(visible)]="isShowInteractiveDemoDisplayReportPreparation"
	[modal]="true"
	[header]="'interactive-demo.demo-report-preparation' | translate"
	allowfullscreen
	[style]="{ width: '85%', height: '100%' }">
	<iframe
		src="
https://app.sharefable.com/embed/demo/rapor-hazrlama-pivot-8w8wctsjidyiz2qi"
		width="100%"
		height="100%"
		style="border: none"
		allowfullscreen></iframe>
</p-dialog>

<p-dialog
	[(visible)]="isShowInteractiveDemoDisplayWidget"
	[modal]="true"
	[header]="'interactive-demo.demo-widget' | translate"
	allowfullscreen
	[style]="{ width: '85%', height: '100%' }">
	<iframe
		src="
https://app.sharefable.com/embed/demo/oluturulan-raporu-dash-ybv36b4f9v1qru8n"
		width="100%"
		height="100%"
		style="border: none"
		allowfullscreen></iframe>
</p-dialog>

<p-tieredMenu [model]="items" [popup]="true" #menu @fade></p-tieredMenu>
